import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AvatarIcon } from "@/lib/identity";
import { Heading, Stat } from "./NKDaily";
import LoadedQuestions from "./LoadedQuestions";

export default function NKSurvivalAdmin() {
  const [state, setState] = useState(null);
  const [users, setUsers] = useState({});

  useEffect(() => {
    const tick = async () => {
      try {
        const r = await api.get("/admin/modes/status");
        setState(r.data.survival);
        // Hydrate user info for the top streaks
        const ids = new Set();
        (r.data.survival.longest_today || []).forEach((s) => ids.add(s.user_id));
        (r.data.survival.longest_season || []).forEach((s) => ids.add(s.user_id));
        if (ids.size > 0) {
          const u = await api.get("/admin/users");
          const map = {};
          for (const x of u.data) map[x.user_id] = x;
          setUsers(map);
        }
      } catch { /* */ }
    };
    tick(); const id = setInterval(tick, 12000); return () => clearInterval(id);
  }, []);

  return (
    <div className="space-y-6">
      <Heading title="NK Survival" subtitle="Endless run. One wrong answer ends it. Combo + milestone bonuses." />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Stat label="Live runs" value={state?.alive ?? "—"} />
        <Stat label="Longest streak today" value={(state?.longest_today || [])[0]?.streak ?? "—"} />
        <Stat label="Longest streak season" value={(state?.longest_season || [])[0]?.streak ?? "—"} />
      </div>

      <section>
        <p className="eyebrow mb-3">Top runs today</p>
        <List rows={state?.longest_today || []} users={users} />
      </section>

      <section>
        <p className="eyebrow mb-3">Top runs this season</p>
        <List rows={state?.longest_season || []} users={users} />
      </section>

      <div className="nk-card p-4">
        <p className="eyebrow mb-2">Scoring config</p>
        <p className="text-sm text-nk-mute">+5 SS per correct · +5 combo every 5 in a row · milestone bonuses at 10/25/50/100 (+25/+50/+100/+250).
        Changing scoring is a backend-side edit — file a Settings task.</p>
      </div>
      <LoadedQuestions mode="survival" />
    </div>
  );
}

function List({ rows, users }) {
  if (rows.length === 0) return <div className="nk-card p-6 text-center text-nk-mute text-sm">No runs yet.</div>;
  return (
    <div className="space-y-1.5">
      {rows.map((s, i) => {
        const u = users[s.user_id];
        return (
          <div key={i} className="nk-card px-4 py-2.5 flex items-center gap-3">
            <span className="font-mono text-xs text-nk-dim w-5">#{i + 1}</span>
            {u && <AvatarIcon id={u.avatar} size={22} />}
            <span className="text-sm flex-1 truncate">{u ? (u.username || u.name) : s.user_id.slice(-8)}</span>
            <span className="font-mono text-nk-accent">{s.streak}</span>
          </div>
        );
      })}
    </div>
  );
}
